import Box from '@mui/material/Box';

import { formatPhoneNumber } from '@/utils/formatters/formatPhoneNumber';

import { dcrFieldValueStyles as sx } from './DCRFieldValue.styles';

const COMMA_LIST_FIELD_KEYS = ['allSpecLocal_V'];

const PHONE_FIELD_KEYS = [
	'officePhoneCda_V',
	'phoneCda_V',
	'faxCda_V',
	'phone1_V',
	'phone2_V',
	'fax1_V'
];

const CommaListValue = ({ value }: { value: string }) => (
	<Box sx={sx.multiLineValue}>
		{value
			.split(',')
			.map(part => part.trim())
			.filter(Boolean)
			.map((part, i) => (
				<Box key={i}>{part}</Box>
			))}
	</Box>
);

type Props = {
	value: string | null | undefined;
	field: string;
	country?: string | null;
};

export const DCRFieldValue = ({ value, field, country }: Props) => {
	if (!value) return <>{value ?? ''}</>;

	if (COMMA_LIST_FIELD_KEYS.includes(field) && value.includes(',')) {
		return <CommaListValue value={value} />;
	}

	if (PHONE_FIELD_KEYS.includes(field)) {
		return <>{formatPhoneNumber(value, country) || value}</>;
	}

	return <>{value}</>;
};
